/**
 * Imported from EN-US
 */

(function ($) {
	var JhAuth = {

		init: function () {

			$( document ).on(
				'click',
				'[href^="https://www.secureaccountview.com"]',
				JhAuth.maybePostLink
			);

			// Adding CSRF to the BFDS anchor tags for live session
			$( document ).on( 'focus', '[href^="https://www.secureaccountview.com"]', function(e) {
				e.preventDefault();

				var url        = $( this ).attr( 'href' );
				var csrf_token = JhAuth.readCookie( 'jhea' ) ? JhAuth.readCookie( 'jhea' ) : jh_bfds_authentication.jhea;
				var BFDS_url   = url + "?csrf_token=" + csrf_token;
			
				$( this ).prop( 'href', BFDS_url );
			});

			JhAuth.maybeCreateCookie();
			JhAuth.readCookie( 'jhea' );
		},

		maybePostLink: function () {
			event.preventDefault();
			var url        = encodeURI($( this ).attr( 'href' ));
			var csrf_token = JhAuth.readCookie( 'jhea' ) ? JhAuth.readCookie( 'jhea' ) : jh_bfds_authentication.jhea;

			JhAuth.checkForLogOut( url, 'jhea' );
			JhAuth.sendForm( url, {'csrf_token': csrf_token}, 'post' );
		},

		// Erases BFDS cookie if URL is logout
		checkForLogOut: function(url, name) {
			if ( typeof url !== "undefined" ) {
				if ( url.substring( url.lastIndexOf( '/' ) + 1 ) === "logOut" ) {
					JhAuth.eraseCookie( name );
				}
			}
		},

		maybeCreateCookie: function () {
			if (jh_bfds_authentication.jhea !== '') {
				JhAuth.createCookie( 'jhea', jh_bfds_authentication.jhea, 1 );
			}
		},

		createCookie: function (name, value, days) {
			var expires = '',
				secure  = '';

			if (days) {
				var date = new Date();
				date.setTime( date.getTime() + (days * 24 * 60 * 60 * 1000) );
				expires = '; expires=' + date.toUTCString();
			}

			// check localized.gwp_environment and set the secure variable if this is not LOCAL
            if( 'LOCAL' !== localized.gwp_environment ){
                secure = '; Secure';
            }

			document.cookie = name + '=' + value + expires + '; path=/' + secure;
		},

		readCookie: function (name) {
			var nameEQ = name + '=';
			var ca     = document.cookie.split( ';' );
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt( 0 ) == ' ') {
					c = c.substring( 1, c.length );
				}
				if (c.indexOf( nameEQ ) === 0) {
					return c.substring( nameEQ.length, c.length );
				}
			}

			return null;
		},

		eraseCookie: function (name) {
			if (null !== JhAuth.readCookie( name )) {
				JhAuth.createCookie( name, '', -1 );
			}
		},

		sendForm: function (path, params, method) {
			method = method || 'post';

			var form = document.createElement( 'form' );
			form.setAttribute( 'method', method );
			form.setAttribute( 'action', path );

			for (var key in params) {

				if (params.hasOwnProperty( key )) {
					var hiddenField = document.createElement( 'input' );
					hiddenField.setAttribute( 'type', 'hidden' );
					hiddenField.setAttribute( 'name', key );
					hiddenField.setAttribute( 'value', params[key] );

					form.appendChild( hiddenField );
				}
			}

			document.body.appendChild( form );
			form.submit();
		},

	};

	$( document ).ready(
		function () {
			JhAuth.init();
		}
	);

})( jQuery );
